export default __webpack_public_path__ + "static/media/fish necklace red.716f33e7.png";